export default __webpack_public_path__ + "static/media/backend-guild-background.b879e9d2.png";